import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { BaseResponse } from "../_types";
import { useMutation } from "react-query";

export type DeleteMasterPassRequest = {
  id: number | string;
};

export type DeleteMasterPassResponse = BaseResponse<any>;

async function deleteMasterPass(
  data: DeleteMasterPassRequest
): Promise<any> {
  try {
    const id1 = data.id;
    return (await axiosInstance.delete(`/MasterPass/DeleteDefinition?id=${id1}`)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteMasterPass() {
  return useMutation<any, Error, DeleteMasterPassRequest>(
    (variables) => deleteMasterPass(variables)
  );
}
